import { render, staticRenderFns } from "./answerQuestion.vue?vue&type=template&id=530e6197&scoped=true"
import script from "./answerQuestion.vue?vue&type=script&lang=js"
export * from "./answerQuestion.vue?vue&type=script&lang=js"
import style0 from "./answerQuestion.vue?vue&type=style&index=0&id=530e6197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e6197",
  null
  
)

export default component.exports